import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDipDetailDocument,
  type GetDipDetailQuery,
  type GetDipDetailQueryVariables,
} from "~/features/dataImportProjects/gqls";

/** Read-only DIP detail (project info). Tenant scoped server-side via the Hasura session. */
export function useDipDetail(id: string) {
  // cache-and-network so the detail revalidates on mount — after defining a data source in the
  // designer sub-page, the bootstrap mutation returns only a status result (can't normalize the new
  // dataSourceImportProjects into cache), so a plain cache-first read would show the DIP as empty.
  return useSuspenseQuery<GetDipDetailQuery, GetDipDetailQueryVariables>(GetDipDetailDocument, {
    variables: { id },
    fetchPolicy: "cache-and-network",
  });
}
